import type { CancelablePromise } from '/src/api';
import { OpenAPI, request as __request } from '/src/api';

export class KwhImporterService {
  /**
   * Import kWh data from Excel file
   * @param file File to import
   * @returns Import result
   * @throws ApiError
   */
  public static import(file: File): CancelablePromise<{ message: string }> {
    const formData = new FormData();
    formData.append('file', file);

    return __request(OpenAPI, {
      method: 'POST',
      url: '/importers/kwh',
      body: formData,
    });
  }
}
